import { beeXLogger } from '../helpers/logger';
import {
  parseResponseBody,
  prepareBody,
  requestSocketPromiseWithTimeout,
} from './query';
import * as SERVICE from '../constants/service.types';

export const removeMember = async (input) => {
  beeXLogger.debug(
    '🚀 ~ removeMember ~ prepareBody(input):',
    prepareBody(input),
  );
  const response = await requestSocketPromiseWithTimeout(
    {
      body: prepareBody(input),
      appServiceType: SERVICE.REMOVE_MEMBER,
    },
    { timeout: 120000 },
  );
  beeXLogger.debug('response:removeMember ', parseResponseBody(response));

  return parseResponseBody(response);
};
